import { Injectable, signal } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface SubPage {
  label: string;
  path: string;
}

@Injectable()
export class SidebarItemStore {
  /** PROPERTIES **/
  /****/
  private readonly _icon = signal<IconProp>(null!);

  /****/
  private readonly _mainLabel = signal<string>('');

  /****/
  private readonly _mainPath = signal<string>('');

  /****/
  private readonly _subPages = signal<SubPage[] | null>(null);

  /****/
  private readonly _isExpanded = signal<boolean>(false);

  /****/
  public readonly icon = this._icon.asReadonly();

  /****/
  public readonly mainLabel = this._mainLabel.asReadonly();

  /****/
  public readonly mainPath = this._mainPath.asReadonly();

  /****/
  public readonly subPages = this._subPages.asReadonly();

  /****/
  public readonly isExpanded = this._isExpanded.asReadonly();

  init(
    icon: IconProp,
    mainLabel: string,
    mainPath: string,
    subPages: SubPage[] | null
  ): void {
    this._icon.set(icon);
    this._mainLabel.set(mainLabel);
    this._mainPath.set(mainPath);
    this._subPages.set(subPages);
  }

  setExpanded(value: boolean): void {
    this._isExpanded.set(value);
  }

  toggleExpanded(): void {
    this._isExpanded.update(cur => !cur);
  }
}

export function provideSidebarItemStore() {
  return [SidebarItemStore];
}
